import { PersonController } from './person.controller';
import template from './person.html';

export const createRequestPersonComponent = {
  name: 'createRequestPerson',
  restrict: 'E',
  template,
  controller: PersonController,
  controllerAs: 'vm',
  bindings: {
    descriptionTitle: '@',
    descriptionText: '@',
    prefix: '@',
    model: '=',
    form: '=',
    canNotAddAdditionalAccountOwners: '=',
    doNotShowBirthday: '=',
  },
};
